import { Reveal, Chapter } from "./shared";

const STEPS = [
  {
    num: "01",
    title: "Free Website & SEO Check",
    desc: "We review your current site, search rankings, and Google Business Profile at no cost.",
  },
  {
    num: "02",
    title: "We Confirm the Scope",
    desc: "Start with the Growth plan. Add a custom tool or AI automation whenever you're ready for it.",
  },
  {
    num: "03",
    title: "We Build and Optimize",
    desc: "We build your new website, launch your site, and optimize your search presence.",
  },
  {
    num: "04",
    title: "You Get More Leads",
    desc: "More calls. More form fills. More customers walking through your door.",
  },
];

const HowItWorks = () => (
  <section id="how-it-works" className="py-16 sm:py-24 lg:py-28 bg-white border-y border-[#e7e1d6]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl mx-auto text-center flex flex-col items-center gap-4 mb-14">
        <Chapter num="03" label="Process" />
        <Reveal delay={0.1}>
          <h2 className="text-3xl sm:text-4xl font-serif font-normal tracking-tight text-[#16324a]">
            How It Works
          </h2>
        </Reveal>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
        {STEPS.map((step, i) => (
          <Reveal key={step.num} delay={0.1 * i}>
            <div data-testid={`how-step-${i + 1}`} className="flex flex-col gap-4">
              <div className="flex items-center gap-4">
                <span className="font-serif italic text-4xl sm:text-5xl text-[#c99a43] leading-none">
                  {step.num}
                </span>
                <span className="h-px flex-1 bg-[#e7e1d6]" />
              </div>
              <h3 className="font-serif text-xl sm:text-2xl font-medium text-[#16324a]">{step.title}</h3>
              <p className="text-[15px] text-[#334e68] leading-relaxed">{step.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
